const appparameters = require("./../core/common.jsx");
const mqtt = require("mqtt");
const mqtt_topics = require("./../../src/mqtt/mqtt_topics");

module.exports = {
  connect: function () {
    const isProd = appparameters.profile === 1;

    // Follow the same scheme as the rest of the app rather than assuming
    // release == TLS. A browser on http:// cannot open a wss:// socket, and a
    // browser on https:// refuses a plain ws:// one, so this must track
    // appprotocol (driven by REACT_APP_APPPROTOCOL) - not the profile flag.
    const wsProtocol = appparameters.appprotocol === "https" ? "wss" : "ws";

    // Construct URL
    const url = isProd
      ? `${wsProtocol}://${appparameters.appdomain}/ws/` // Production: via the Apache proxy on 443/80
      : `${wsProtocol}://${appparameters.appdomain}:${mqtt_topics.websocketport}/ws/`; // Dev: direct to RabbitMQ

    //console.log("Profile:", appparameters.profile);
    //console.log("Connecting to MQTT URL:", url);

    const options = {
      protocol: wsProtocol,
      username: process.env.REACT_APP_MQTT_FrontEnd_Username,
      password: process.env.REACT_APP_MQTT_FrontEnd_Password,
      clientId: "mqttjs_" + Math.random().toString(16).substr(2, 8),
      clean: true,
      keepalive: 60, // ✅ send MQTT ping every 60s
      reconnectPeriod: 1000, // reconnect every 1s if dropped
      connectTimeout: 30 * 1000,
      resubscribe: true,
      qos: 0,
      retain: false,
    };

    return mqtt.connect(url, options);
  },
};

//import mqtt_topics from "./../../src/mqtt/mqtt_topics";
/*const appparameters = require("./../core/common.jsx");
module.exports = {
  connect: function () {
    var mqtt_topics = require("./../../src/mqtt/mqtt_topics");
    var mqtt = require("mqtt");
    var options = {
      protocol: "mqtt",
      username: process.env.REACT_APP_MQTT_FrontEnd_Username,
      password: process.env.REACT_APP_MQTT_FrontEnd_Password,
      qos: 1,
      retain: false,
      clientId: "mqttjs_" + Math.random().toString(16).substr(2, 8),
      clean: true,
      keepalive: 0,
      reconnectPeriod: 1000,
      connectTimeout: 30 * 1000,
      resubscribe: true, // Automatically resubscribe after reconnecting
    };
    return mqtt.connect(
      "ws://" +
        appparameters.appdomain +
        ":" +
        mqtt_topics.websocketport +
        "/ws",
      options
    );
  },
};*/
